import styled from "styled-components";
import Header from "../components/header/Header";
import DayPlannerTourGroupsContent from "../components/bookings_manager/day_planner_tour_groups/content/DayPlannerTourGroupsContent";
import { useNavigate } from "react-router-dom";

//-------------------------------------------------

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

//-------------------------------------------------

const DayPlannerWithTourGroups = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header
        text={"Day Planner"}
        redirectFn={() => {
          navigate("/home");
        }}
      />
      <ContentContainer>
        <DayPlannerTourGroupsContent />
      </ContentContainer>
    </Container>
  );
};
export default DayPlannerWithTourGroups;
